import CardAboutModal from "./CardAboutModal";
import PlayBox from "./PlayBox";
import ThisIsModal from "./ThisIsModal";
import Thumbnail from "./Thumbnails";
import { Songcard } from "@/types";
import {
  Box,
  Card,
  CardBody,
  Center,
  Divider,
  HStack,
  Stack,
  Text,
  useColorMode,
} from "@chakra-ui/react";
import { useInView } from "framer-motion";
import Link from "next/link";
import { useRef, useState } from "react";

export default function ExampleCard() {
  const { colorMode } = useColorMode();
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true });
  const [modelOpen, setModalOpen] = useState(false);

  const example: Songcard = {
    id: 148,
    embed: false,
    title: "You Say To Me feat. Elena K (Standard Edition)",
    image: "https://dfkbrdbkwd97.cloudfront.net/YSTMOPTIMISED.gif",
    comp_file: "https://dfkbrdbkwd97.cloudfront.net/YSTMOPTIMISED.gif",
    song: {
      title: "You Say To Me (feat. Elena K)",
      file: "https://dfkbrdbkwd97.cloudfront.net/Raven_feat._Elena_K_-_You_Say_To_Me.mp3",
      ext_file:
        "https://dfkbrdbkwd97.cloudfront.net/Raven_feat._Elena_K_-_You_Say_To_Me.mp3",
    },
    desc: "This was the very first song I made as Raven.\r\n\r\nIn the beginning it was more a way to help me deal with the break-up of my ex-girlfriend who left me heartbroken up to this very day.\r\nAfter feeling that I love rapping and professional music production, It quickly became a serious business. So this song was the start of a very important part of my life. \r\n\r\nThis Songcard is also available as Collectors Edition with extended content.",
    uuid: "075956df-e32d-406e-98b1-467269f58f08",
    primary_artist: {
      id: 0,
      name: "Raven",
      slug: "raven",
      about: "",
      profile_image: "",
      cards: [],
    },
    ext_file: "",
    files: [],
  };

  return (
    <div>
      <Center
        ref={ref}
        style={{
          transform: isInView ? "none" : "translateY(+100px)",
          transition: "all 0.9s cubic-bezier(0.17, 0.55, 0.55, 1) 0.5s",
        }}
      >
        <Card
          maxW="xs"
          align="center"
          bgColor={colorMode == "dark" ? "black" : "white"}
          variant="outline"
          borderColor={colorMode == "dark" ? "white" : "black"}
          borderStyle="dotted"
          borderRadius={15}
          shadow={"md"}
        >
          <CardBody>
            <Link href={`cards/${example.uuid}`}>
              <Center>
                <Box height={285} width={285}>
                  <Thumbnail
                    ext_file={""}
                    comp_file={example.image}
                    image={""}
                  />
                </Box>
              </Center>
            </Link>
            <Stack mt="4" mb="0" spacing="3">
              <Center>
                <PlayBox card={example} />
              </Center>
              <Text ml={4} mb={0} mt={2}>
                is a Songcard from
                <br />
                {example.primary_artist && (
                  <Text as="b" key={example.primary_artist.slug}>
                    <Link href={`/artists/${example.primary_artist.slug}`}>
                      {example.primary_artist.name}
                    </Link>
                  </Text>
                )}
              </Text>
              <Divider mb={0} />
              <Center>
                <HStack justify="space-between" w="94%">
                  <CardAboutModal
                    card={example}
                    price={false}
                    showOpen={true}
                  />
                  <ThisIsModal
                    card={example}
                    price={false}
                    showOpen={modelOpen}
                    setModalOpen={setModalOpen}
                  />
                </HStack>
              </Center>
            </Stack>
          </CardBody>
        </Card>
      </Center>
    </div>
  );
}
